import { Box, CenterAlignedLoader } from '@medly-components/core';

export const FullScreenLoader = ({ loading = false }: { loading?: boolean }) => {
    return loading ? (
        <Box
            width="100%"
            height="100vh"
            data-testid="full-screen-loader"
            style={{
                position: 'fixed',
                zIndex: 999,
                padding: 0,
                margin: 0,
                top: 0,
                left: 0,
                opacity: 0.6,
                background: 'rgba(67, 84, 101, 0.5)',
                cursor: 'progress'
            }}
        >
            <CenterAlignedLoader position="relative" />
        </Box>
    ) : null;
};
